/* tslint:disable */
 
import { ReferenceProperty } from './reference-property';
export class MyDelegationsDto {
  delegator: ReferenceProperty;
  from_date: string;
  id: string;
  to_date?: null | string;
}
